'use client';
import { CircleCheckIcon, TriangleAlertIcon } from 'lucide-react';
import { Toaster, resolveValue } from 'react-hot-toast';

const iconSize = 16;

const alertClassMap = {
  success: {
    icon: <CircleCheckIcon size={iconSize} />,
    className: 'alert-success',
  },
  error: {
    icon: <TriangleAlertIcon size={iconSize} />,
    className: 'alert-error',
  },
  loading: {
    icon: <span className='loading loading-spinner loading-xs'></span>,
    className: '',
  },
  blank: {
    icon: null,
    className: '',
  },
  custom: {
    icon: null,
    className: '',
  },
};

const Toast = () => {
  return (
    <Toaster>
      {t => {
        const alertClass = alertClassMap[t.type]?.className || '';
        const alertIcon = alertClassMap[t.type]?.icon || null;

        return (
          <div className='toast toast-top toast-center'>
            <div className={`alert ${alertClass} text-md`}>
              {t.icon
                ? resolveValue(t.icon, t)
                : alertIcon
                  ? resolveValue(alertIcon, t)
                  : null}
              <span>{resolveValue(t.message, t)}</span>
            </div>
          </div>
        );
      }}
    </Toaster>
  );
};

export default Toast;
